import { create } from 'zustand';

const DEMO_ENTRIES = [
  { id: 'a1', action: 'member_ban',      actorName: 'AeThex Dev', targetName: 'spammer99',  detail: 'Repeated spam and rule violations',       timestamp: Date.now() - 300000 },
  { id: 'a2', action: 'message_delete',  actorName: 'AeThex Dev', targetName: 'nova',        detail: 'Message contained prohibited content',    timestamp: Date.now() - 900000 },
  { id: 'a3', action: 'role_change',     actorName: 'AeThex Dev', targetName: 'drift',       detail: 'Promoted to Moderator',                   timestamp: Date.now() - 3600000 },
  { id: 'a4', action: 'channel_create',  actorName: 'AeThex Dev', targetName: '#announcements', detail: 'Type: announcement',                  timestamp: Date.now() - 7200000 },
  { id: 'a5', action: 'slow_mode_set',   actorName: 'AeThex Dev', targetName: '#general',    detail: 'Slowmode set to 5 seconds',               timestamp: Date.now() - 10800000 },
  { id: 'a6', action: 'invite_generate', actorName: 'nova',       targetName: null,          detail: 'Uses: unlimited · Expires: 7 days',       timestamp: Date.now() - 14400000 },
  { id: 'a7', action: 'member_kick',     actorName: 'AeThex Dev', targetName: 'badactor42',  detail: 'Harassment in #general',                  timestamp: Date.now() - 86400000 },
  { id: 'a8', action: 'server_edit',     actorName: 'AeThex Dev', targetName: null,          detail: 'Updated server description and icon',     timestamp: Date.now() - 172800000 },
  { id: 'a9', action: 'member_timeout',  actorName: 'AeThex Dev', targetName: 'echo',        detail: 'Timed out for 10 minutes · Off-topic spam', timestamp: Date.now() - 259200000 },
  { id: 'a10', action: 'automod_trigger', actorName: 'AutoMod',   targetName: 'newuser12',   detail: 'Flagged: repeated mentions (5)',           timestamp: Date.now() - 345600000 },
];

export const useAuditStore = create((set, get) => ({
  entries: [...DEMO_ENTRIES],

  addEntry: (action, actorName, targetName, detail) => {
    const entry = {
      id: `audit-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
      action,
      actorName,
      targetName,
      detail,
      timestamp: Date.now(),
    };
    set(s => ({ entries: [entry, ...s.entries] }));
    return entry;
  },

  getEntries: (filter = 'all') => {
    const { entries } = get();
    return filter === 'all' ? entries : entries.filter(e => e.action === filter);
  },
}));
